/* eslint-disable func-names */
export default function sleep(delay) {
  return new Promise(function (resolve) {
    setTimeout(resolve, delay);
  });
}
